import { type FC } from 'react';
import { type Control, Controller } from 'react-hook-form-latest';
import Switch from '@/components/UI/FormElements/Switch';
import { type TeamConfigFormValues } from './TeamConfig.utils';
import styles from './TeamConfig.module.scss';

interface StudiesReadAllCardProps {
  control: Control<TeamConfigFormValues>;
  testId?: string;
}

/**
 * Non-expandable config card for the studies_read_all setting.
 * Toggles whether all tenant users can read every study regardless of permissions.
 */
const StudiesReadAllCard: FC<StudiesReadAllCardProps> = ({ control, testId = 'studies-read-all-card' }) => (
  <div className={styles.card} data-testid={testId}>
    <div className={styles.cardHeader}>
      <div>
        <span className="fw6 f5">Studies Read All</span>
        <p className="f6 dark-gray lh-copy mt2 mb0">
          When active, all users in this tenant can read every study, regardless of individual study permissions.
        </p>
      </div>
      <div className="flex items-center" style={{ gap: '0.75rem' }}>
        <Controller
          name="studies_read_all.active"
          control={control}
          render={({ field: { onChange, value } }) => (
            <>
              <span className="f6 mid-gray">{value ? 'Active' : 'Inactive'}</span>
              <Switch value={value} onChange={onChange} testId={`${testId}-switch`} />
            </>
          )}
        />
      </div>
    </div>
  </div>
);

export default StudiesReadAllCard;
